import { apiJson } from './http';

/* ====== Types ====== */
export type BillingMonth = {
  month: number;                // 1..12
  paid: boolean;
  paidAt?: string | null;       // ISO
  amountEuro?: number | null;   // euro con decimali
  note?: string | null;
};

export type BillingRow = {
  customerId: number;
  customerName: string;
  months: Record<number, BillingMonth>; // chiavi 1..12
};

export type SetPaidRequest = {
  paid: boolean;
  amountEuro?: number | null;
  note?: string | null;
  paidAt?: string | null; // opzionale; se assente e paid=true -> server usa now
};

/* ====== API ====== */
export async function getBillingStatus(
  year: number,
  customerId?: number
): Promise<BillingRow[]> {
  const params = new URLSearchParams({ year: String(year) });
  if (customerId) params.set('customerId', String(customerId));
  return apiJson<BillingRow[]>(`/p/billing/status?${params.toString()}`);
}

export async function setBillingMonth(
  customerId: number,
  year: number,
  month: number,
  body: SetPaidRequest
): Promise<BillingMonth> {
  return apiJson<BillingMonth>(`/p/billing/status/${customerId}/${year}/${month}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}
